export const TRANSITION_ENDED = '@@mah-user/TRANSITION_ENDED';